var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#60C8DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.5 31.5C27.4706 31.5 31.5 27.4706 31.5 22.5C31.5 17.5294 27.4706 13.5 22.5 13.5C17.5294 13.5 13.5 17.5294 13.5 22.5C13.5 27.4706 17.5294 31.5 22.5 31.5Z",
    fill: "#0C191C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 31.5C27.4706 31.5 31.5 27.4706 31.5 22.5C31.5 17.5294 27.4706 13.5 22.5 13.5C17.5294 13.5 13.5 17.5294 13.5 22.5C13.5 27.4706 17.5294 31.5 22.5 31.5Z",
    stroke: "#0C191C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3975 24.7496C26.0021 25.4335 25.4338 26.0013 24.7496 26.396C24.0654 26.7907 23.2894 26.9985 22.4995 26.9986C21.7096 26.9986 20.9336 26.7908 20.2494 26.396C19.5652 26.0013 18.9969 25.4335 18.6016 24.7497",
    stroke: "#0C191C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 21.75C19.7463 21.75 20.25 21.2463 20.25 20.625C20.25 20.0037 19.7463 19.5 19.125 19.5C18.5037 19.5 18 20.0037 18 20.625C18 21.2463 18.5037 21.75 19.125 21.75Z",
    fill: "#0C191C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 21.75C26.4963 21.75 27 21.2463 27 20.625C27 20.0037 26.4963 19.5 25.875 19.5C25.2537 19.5 24.75 20.0037 24.75 20.625C24.75 21.2463 25.2537 21.75 25.875 21.75Z",
    fill: "#0C191C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileactive);
export default __webpack_public_path__ + "static/media/profileactive.f6e12aa935364e7f1313e7c70ba75962.svg";
export { ForwardRef as ReactComponent };